import { Link } from 'react-router-dom';
import { categories } from '@/mocks/events';

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100 md:mt-24">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5" aria-label="高校吃瓜社 首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl leading-none" aria-hidden="true"></i>
              </span>
              <strong className="font-heading text-lg font-black text-background-50">高校吃瓜社</strong>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              聚焦校园公共话题，梳理事件脉络与时间线。围观有分寸，吃瓜不迷路。
            </p>
            <p className="mt-4 text-xs text-background-300">
              站内校园名称均已模糊化处理，不涉及真实个人信息。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <Link to="/#events" className="hover:text-accent-400">逛内容</Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-background-200 transition-colors hover:text-accent-400">
                  事件合集
                </Link>
              </li>
              <li>
                <Link to="/events?cat=campus-life" className="text-background-200 transition-colors hover:text-accent-400">
                  校园生活
                </Link>
              </li>
              <li>
                <Link to="/events?cat=study-exam" className="text-background-200 transition-colors hover:text-accent-400">
                  学业考场
                </Link>
              </li>
              <li>
                <Link to="/events?cat=heart-station" className="text-background-200 transition-colors hover:text-accent-400">
                  情感小站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">热门话题</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/events?cat=${cat.id}`}
                    className="inline-block rounded-full bg-secondary-800 px-3 py-1.5 text-xs text-background-100 transition-colors hover:bg-secondary-700 hover:text-accent-400"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">关于与联系</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-background-200 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#principles" className="text-background-200 transition-colors hover:text-accent-400">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-background-200 transition-colors hover:text-accent-400">
                  联系我们
                </Link>
              </li>
              <li className="flex items-center gap-2 text-background-200">
                <i className="ri-mail-line text-base leading-none text-accent-400" aria-hidden="true"></i>
                contact@gaoxiaochigua.com
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 高校吃瓜社 · 围观校园热门现场，理性看待每一件事</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>内容由同学投稿与公开信息整理</span>
            <span className="hidden sm:inline">·</span>
            <span>本站内容仅作话题讨论</span>
          </p>
        </div>
      </div>
    </footer>
  );
}